import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, map, tap, Observable } from 'rxjs';
import { PredictorModelActions } from 'src/app/state/predictor-model/predictor-model.actions';
import { UserActions } from '../../state/user/user.actions';
import { UserState } from '../../state/user/user.state';
import { FeaturesActions } from '../../state/features/features.actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const authenticatedUserResolver: () => Observable<any> = () => {
  const store: Store = inject(Store);
  return combineLatest([
    store.dispatch(new UserActions.SetUserProfileInformation()),
    store.dispatch(new PredictorModelActions.GetConfigurationProfiles()),
    store.dispatch(new FeaturesActions.SetApplicationFeatures()),
  ]).pipe(
    tap(() => {
      store.dispatch(new UserActions.SetUserImage());
    }),
    map(() => store.selectSnapshot(UserState.userProfile))
  );
};
